import styled from "styled-components";

const DialogWrapper = styled.div`
  z-index: 9999;
  display: ${(props) => (props.open ? "" : "none")};
`;

export default DialogWrapper;
